module.exports = __webpack_public_path__ + "img/publish_Bg.bd929fe.png";